import { render, staticRenderFns } from "./PlaceCarrierBookingList.vue?vue&type=template&id=6168945e&"
import script from "./PlaceCarrierBookingList.vue?vue&type=script&lang=js&"
export * from "./PlaceCarrierBookingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6168945e')) {
      api.createRecord('6168945e', component.options)
    } else {
      api.reload('6168945e', component.options)
    }
    module.hot.accept("./PlaceCarrierBookingList.vue?vue&type=template&id=6168945e&", function () {
      api.rerender('6168945e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/CustomActions/PlaceCarrierBooking/PlaceCarrierBookingList.vue"
export default component.exports